import { getScreenNameAuthenticated } from "../../utils/auth/Auth-utils";
import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerAccessToken = async () => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_GET_TOKEN_ACCESS,
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY_NGINX,
            'Content-Type'              : 'application/json'
        }),
        body: JSON.stringify({
            resource: process.env.REACT_APP_RESOURCE_ID
        })
    })
}

export const obtenerTablasMaestras = async () => {
    let parametros = [{ campo: 'id', valor: process.env.REACT_APP_SD_WEB_TABLAS_MAESTRAS }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(process.env.REACT_APP_WS_GET_DATAS_MAESTRAS, parametros),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}

export const obtenerTablaMaestraCodigo = async(codigoTabla) => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_GET_TABLAS_MAESTRAS + codigoTabla,
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated(),
            'Content-Type'              : 'application/json'
        })
    })
}

export const obtenerPersonID = async (numDocumento) => {
    let atributos = [{ campo: 'numDocumento', valor: numDocumento }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_OBTENER_PERSON_ID, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Content-Type'              : 'application/json'
        })
    })
}

export const obtenerListaDistritos = () => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_GET_GEOGRAPHIC_LOCATION_ECOMMERCE,
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated(),
            'Content-Type'              : 'application/json'
        })
    })
}

export const validarPersonID = async (idSolicitudMultiple, solicitudes) => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_POST_VALIDAR_PERSONA_ID,
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'idTransaccion'             : FuncionesServices.generarCorrelativo(),
            'correlativoId'             : FuncionesServices.generarCorrelativo(),
            'procesoNegocio'            : process.env.REACT_APP_BUSINESS_PROCESS,
            'nombreAplicacion'          : process.env.REACT_APP_NOMBRE_APLICACION,
            'usuarioAplicacion'         : 'test',
            'Content-Type'              : 'application/json'
        }),
        body: JSON.stringify({
            idSolicitudMultiple: idSolicitudMultiple,
            idSolicitud: solicitudes
        })
    })
}

export const obtenerParametros = async() => {
    let parametros = [{ campo: 'id', valor: process.env.REACT_APP_SD_WEB_PARAMETROS }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(process.env.REACT_APP_WS_GET_PARAMETROS, parametros),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}

export const validarPersonas = async(tipoDoc, numeroDoc) => {
    let atributos = [
        { campo: 'tipoDocumento', valor: tipoDoc },
        { campo: 'numeroDocumento', valor: numeroDoc }
    ]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_VALIDACION_PERSONAS, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'idTransaccion'             : FuncionesServices.generarCorrelativo(),
            'correlativoId'             : FuncionesServices.generarCorrelativo(),
            'procesoNegocio'            : process.env.REACT_APP_BUSINESS_PROCESS,
            'nombreAplicacion'          : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}

export const obtenerEntidadesFinancieras = async() => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_GET_ENTIDADES_BANCARIAS,
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}